// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"AddressAutoComplete_searchBox__1DUOd","suggestions":"AddressAutoComplete_suggestions__2bfMX","suggestionItem":"AddressAutoComplete_suggestionItem__3z32d"};